import React from 'react';
import './SubmitModal.scss';
import Close from '../../images/close.svg';
import Dialog from '../Dialog';

const SubmitModalWrapper = ({ showModal, onClose, colorCode, children }) => {
  if (!showModal) return null;

  return (
    <Dialog open={showModal} className="cotizacion-rapida" color={colorCode}>
      <div>
        <div className="cotizacion-rapida__icon">
          <button disabled={false} 
              onClick={() => {
                onClose();
              }}>
            <img src={Close} alt="Close" />
          </button>
        </div>
        {children}
      </div>
    </Dialog>
  );
};

export default SubmitModalWrapper;